var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',{attrs:{"transform":"translate(-1377 -785) translate(1368) translate(0 80) translate(0 656) translate(9 49)"}},[_c('rect',{attrs:{"width":"16.5","height":"2.063","x":"3.75","y":"10.969","rx":"1.031"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }